import { PlayerUserDetailSkeleton } from "components/Skeleton/PlayerUsersPage/PlayerUserDetailSkeleton";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import client from "libs/client";
import { useEffect } from "react";
import { useParams } from "react-router";
import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox";
import NotFoundPage from "./errorPages/NotFoundPage";
import { DiscoverPlayerDataResponse } from "libs/apiClient";
import {DiscoverBreadcrumbs} from "features/discover/DiscoverBreadcrumbs";
import {DiscoverPlayerDataDetail} from "features/discover/DiscoverPlayerDataDetail";

export function DiscoverPlayerDataPage() {
    const { id } = useParams();

    useEffect(() => { setScrollBehavior() }, [])

    const { data: response, isLoading, error } = client.getDiscoverPlayerData.useQuery({ id: parseInt(id || "") }, { queryKey: ["discoverPlayerDataDetail"] })

    if (error) {
        const code = error?.response.status;

        if (code === 404) {
            return (
                <div>
                    <NotFoundPage />
                </div>
            );
        }
    }

	const data: DiscoverPlayerDataResponse = response?.data || {} as DiscoverPlayerDataResponse

	return (
        <div className="discover-container">
            <div className="pageHeading">
				{isLoading
					? <SkeletonBox style={{ width: "300px", height: "32px", margin: "35px 0 35px 0" }} />
					: <DiscoverBreadcrumbs items={[
						{
							label: 'Players data',
							route: '/discover/player-data'
						},
						{
							label: `${data.firstName || ''} ${data.lastName || ''}`,
							note: data.id,
						},
					]} />
				}
            </div>
			{isLoading
				? <PlayerUserDetailSkeleton />
				: <DiscoverPlayerDataDetail playerData={data} />}
        </div>
    )
}
